import { ItemQuestionario } from "src/app/questionario/questao/item-questionario-base";
import { TipoItemQuestionario } from "src/app/questionario/questao/model/tipo-item-questionario.enum";

export class ItemQuestionarioSecao extends ItemQuestionario<ItemQuestionarioSecao> {

  constructor(options: {} = {}) {
    super();
    this.questao.tipo = TipoItemQuestionario.SECAO;
  }

  getLabel(): string {
    return 'Seção';
  }

  getMaterialIcon(): string {
    return 'topic';
  }

  isQuestaoEstruturada(): boolean {
    return false;
  }

}